import SvgIcon from "../../../../parts/SvgIcon";
import Avatar from "../../../../parts/avatar";
import ToggleLinks from "../../../../parts/inputs/toggle-links-input";
import PaginationState from "../../../../parts/pagination-state";

const SubscribersTable = ({
  tableTitle = "Subscriber list",
  sortConfig,
  handleSort,
  subscribers,
  type,
  allActiveSubs,
  allChurnedSubs,
  onActivePageChanged,
  onChurnedPageChanged,
  csvString,
  nameString = "Subscriber",
  onDetailsClick,
  search,
  setSearch,
  productType,
}) => {
  return (
    <>
      <header className="table-header">
        <hgroup>
          <input
            type="search"
            className="text-input"
            name="search"
            placeholder="Type to search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            data-expandable="true"
          />
          <div className="table-toggle">
            <ToggleLinks
              name="type"
              options={[
                { text: "Active", value: "active" },
                { text: "Churned", value: "churned" },
              ]}
              defaultActive="active"
            />
          </div>
        </hgroup>
        <a
          role="button"
          target="_blank"
          href={`data:attachment/csv,${encodeURIComponent(csvString)}`}
          download={`${nameString}s.csv`}
          data-button-type="primary"
        >
          Export to csv
        </a>
      </header>
      <section role="table-wrapper" data-borders-inside>
        <table role="report-table" className="subscribers-table">
          <thead role="table-header">
            <tr>
              <th>
                {nameString}{" "}
                <SvgIcon
                  src="/img/svg/up_down_arrows.svg"
                  onClickFn={(_) =>
                    handleSort(
                      { target: { value: "customer_name" } },
                      sortConfig.key === "customer_name" &&
                        sortConfig.direction !== "descending"
                        ? "descending"
                        : "ascending"
                    )
                  }
                />
              </th>
              <th>
                Plan{" "}
                <SvgIcon
                  src="/img/svg/up_down_arrows.svg"
                  onClickFn={(_) =>
                    handleSort(
                      { target: { value: "plan.interval" } },
                      sortConfig.key === "plan.interval" &&
                        sortConfig.direction !== "descending"
                        ? "descending"
                        : "ascending"
                    )
                  }
                />
              </th>
              <th>Joining date</th>
              <th>Last payment</th>
              <th>Email</th>
              {productType === "membership" && <th>Phone Number</th>}
              <th className="text-center">Action</th>
            </tr>
          </thead>
          {subscribers && subscribers.length > 0 ? (
            <BodyTableComponent
              subscribers={subscribers}
              productType={productType}
              onDetailsClick={onDetailsClick}
            />
          ) : (
            <BodyTableEmptyStateComponent type={type} searchString={search} />
          )}
        </table>
      </section>
      <div className="table-section my-4">
        {allActiveSubs.length !== 0 && type !== "churned" && (
          <div className="pagination-wrapper">
            <PaginationState
              totalRecords={allActiveSubs.length}
              pageLimit={1000}
              pageNeighbours={1}
              onPageChanged={onActivePageChanged}
            />
          </div>
        )}
        {allChurnedSubs.length !== 0 && type === "churned" && (
          <div className="pagination-wrapper">
            <PaginationState
              totalRecords={allChurnedSubs.length}
              pageLimit={1000}
              pageNeighbours={1}
              onPageChanged={onChurnedPageChanged}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default SubscribersTable;

const BodyTableComponent = ({ subscribers, productType, onDetailsClick }) => {
  return (
    <tbody>
      {subscribers.map((sub) => (
        <tr key={sub.id}>
          <td>
            <div className="flex items-center gap-2">
              <div className="image-wrapper">
                {sub.customer_avatar ? (
                  <Avatar size="32" url={sub.customer_avatar.url} user={{}} />
                ) : (
                  <div className="subscriber-icon"></div>
                )}
              </div>
              <span className="subscriber-text">{sub.customer_name}</span>
            </div>
          </td>
          <td>{sub.plan.interval}</td>
          <td>{sub.created}</td>
          <td>{sub.current_period_start}</td>
          <td className="email">
            <a href={`mailto:${sub.customer_email}`}>{sub.customer_email}</a>
          </td>
          {productType === "membership" && <td>{sub.phoneNumber}</td>}
          <td>
            <button
              onClick={(e) => {
                onDetailsClick(e, sub.customer);
              }}
            >
              <span className="clipped p-0">
                <b>Details</b>
              </span>
            </button>
          </td>
        </tr>
      ))}
    </tbody>
  );
};

const BodyTableEmptyStateComponent = ({ type, searchString }) => {
  return (
    <tbody>
      <tr>
        <td colSpan="100%">
          <div className="body-table-empty">
            {searchString ? (
              <>
                <span>No results found for:</span>
                <p>{searchString}</p>
              </>
            ) : (
              <>
                <p>
                  {type !== "churned"
                    ? "You have no active subscribers"
                    : "You have no churned subscribers yet"}
                </p>
                <span>
                  {type !== "churned"
                    ? "Once you have active subscribers, their account information will be shown here"
                    : "The account information of subscribers who have canceled their subscriptions will be shown here"}{" "}
                </span>
              </>
            )}
          </div>
        </td>
      </tr>
    </tbody>
  );
};
